import { render, staticRenderFns } from "./ClientFigure.vue?vue&type=template&id=13a7621b&scoped=true"
import script from "./ClientFigure.vue?vue&type=script&lang=js"
export * from "./ClientFigure.vue?vue&type=script&lang=js"
import style0 from "./ClientFigure.vue?vue&type=style&index=0&id=13a7621b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a7621b",
  null
  
)

export default component.exports